import { render, staticRenderFns } from "./monthworkexport.vue?vue&type=template&id=70b490ce&scoped=true&"
import script from "./monthworkexport.vue?vue&type=script&lang=js&"
export * from "./monthworkexport.vue?vue&type=script&lang=js&"
import style0 from "./monthworkexport.vue?vue&type=style&index=0&id=70b490ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b490ce",
  null
  
)

export default component.exports